import CityPageTemplate from "../city-template/CityPageTemplate";
import { devilsLakeConfig } from "./data";

export default function DevilsLakePage() {
  return <CityPageTemplate config={devilsLakeConfig} />;
}